<template>
  <div class="startup-page">
    <StartupsPageContent :startup="startup" :jobs="jobs" :is-careers-page="isPreview" />
  </div>
</template>

<script>
import StartupsPageContent from '@/components/startups/StartupsPageContent';
import JobModel from '@/models/Job';
import { buildMetaHead } from '@/helpers/meta';
import get from 'lodash/get';

export default {
  name: 'PageStartupsDetail',
  components: {
    StartupsPageContent
  },
  layout({ query }) {
    const isPreview = query.careerPagePreview ? true : false;
    return isPreview ? 'careers' : 'default';
  },
  data() {
    return {
      jobs: null
    };
  },
  computed: {
    startup() {
      return this.$store.state.startups.startup;
    },
    isPreview() {
      return get(this.$route, 'query.careerPagePreview', false) ? true : false;
    }
  },
  head() {
    return buildMetaHead({
      title: this.startup.name,
      description: this.startup.whatWeDo
        .replace(/(<([^>]+)>)/gi, ' ')
        .substr(0, 255)
        .trim(),
      path: this.isPreview /*|| !location?.href?.includes('thehub')*/
        ? this.startup.externalDomain
        : this.startup.url,
      isPreview: this.isPreview,
      imageUrl: this.startup.logoImage.thumbnailSizeUrl
    });
  },
  async asyncData({ params, store, $axios, error }) {
    try {
      const [, jobs] = await Promise.all([
        store.dispatch('startups/get', params.id),
        $axios.get('/companies/' + params.id + '/jobs', {
          params: {
            limit: 100
          }
        })
      ]);

      return { jobs: jobs.data };
    } catch (err) {
      error(err);
    }
  },
  mounted() {
    // console.log('carreers page was mounted')
    // console.log('route get', get(this.$route, 'query.careerPagePreview', false))
    // console.log('this.route', this.$route)
  },
  created() {
    // console.log('route get', get(this.$route, 'query.careerPagePreview', false))
    // console.log('this.route', this.$route)
    // console.log('this.startup', this.startup)
    // if (location) {
    //   console.log('location.href', location.href)
    // }
    this.jobs = {
      ...this.jobs,
      docs: this.jobs.docs.map((doc) => new JobModel(doc))
    };
  }
};
</script>
